/// <amd-module name="Repos/CommitsList/Components/HistoryGraphCell" />
import * as React from "react";

import { IHistroyGraphCellRenderer, VisualizationCell } from "./HistoryGraphCell.Props";

export interface IHistoryGraphCellProps {
    cell: VisualizationCell;
    cellId: string;
    className?: string;
    cellRenderer: IHistroyGraphCellRenderer;
    key: string;
    width: number;
    height: number;
    extendedHeight: number;
}

export class HistoryGraphCell extends React.Component<IHistoryGraphCellProps> {
    private canvasElement = React.createRef<HTMLCanvasElement>();
    private canvasContext: CanvasRenderingContext2D | null;
    constructor(props: IHistoryGraphCellProps) {
        super(props);
    }

    public render() {
        const canvasHeight = this.props.extendedHeight > this.props.height ? this.props.extendedHeight : this.props.height;
        const canvasWidth = this.props.width;
        return (
            <canvas
                className={this.props.className}
                id={this.props.cellId}
                width={canvasWidth + "px"}
                height={canvasHeight + "px"}
                ref={this.canvasElement}
            />
        );
    }

    public componentDidMount() {
        this.updateCell();
    }

    public componentDidUpdate(): void {
        this.updateCell();
    }

    private updateCell(): void {
        if (this.canvasElement.current) {
            this.canvasContext = this.canvasElement.current.getContext("2d");
        }

        if (!this.canvasContext || !this.canvasElement.current) {
            return;
        }

        if (this.props.cell) {
            // Draw inside the canvas here
            this.draw();
        } else {
            // Clear the content of the canvas
            this.clear();
        }
    }

    /**
     * Renders into the canvas using the cellRenderer
     */
    private draw(): void {
        if (this.canvasContext) {
            this.props.cellRenderer.drawCell(this.props.cell, this.canvasContext, this.props.width, this.props.height, this.props.extendedHeight);
        }
    }

    /**
     * Clears the content of the canvas
     */
    private clear(): void {
        if (this.canvasContext) {
            this.props.cellRenderer.cleanCell(this.canvasContext, this.props.width, this.props.height, this.props.extendedHeight);
        }
    }
}
